<template>
  <v-overlay
    :model-value="Boolean(id)"
    content-class="document-preview-container"
    @click:outside="close"
    @keydown.esc="close"
  >
    <div>
      <v-sheet class="preview">
        <div
          v-if="loading"
          class="w-100 h-100 d-flex justify-center flex-column"
        >
          <!-- TODO: skeleton -->
          <div class="d-flex justify-center">
            <v-progress-circular
              indeterminate
              color="brandPrimary"
              size="48"
              width="3"
            />
          </div>
        </div>

        <div
          v-if="!loading"
          class="pa-6 d-flex flex-column ga-4"
        >
          <div class="preview-header d-flex align-center">
            <div class="d-flex align-center ga-2 ml-auto">
              <slot name="actions" />
              <v-btn
                size="32"
                variant="plain"
                color="textDarkest"
                @click="close"
              >
                <v-icon icon="$close" />
              </v-btn>
            </div>
          </div>

          <slot />
        </div>
      </v-sheet>
    </div>
  </v-overlay>
</template>

<script setup>
import { useRoute, useRouter } from 'vue-router';
import { computed } from 'vue';

const route = useRoute();
const router = useRouter();

defineProps({ loading: { type: Boolean, default: false } });

const id = computed(() => route.query?.preview);

const close = () => router.replace({
  query: {
    ...route.query,
    preview: undefined,
    type: undefined,
  },
});
</script>

<style scoped lang="less">
:global(.document-preview-container) {
  // move content to the right side of screen
  right: 0;
}

.preview {
  width: 533px;
  height: 100vh;
  overflow-y: auto;
}
</style>
